import { render, staticRenderFns } from "./ChallengeObjectives.vue?vue&type=template&id=00090c37"
import script from "./ChallengeObjectives.vue?vue&type=script&lang=js"
export * from "./ChallengeObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports